import { ref } from 'vue'

export const STATES = {
    CLOSING: 'closing',
    CLOSED: 'closed',
    OPENING: 'opening',
    OPEN: 'open',
}

export default function useModalState(emit) {
    const current = ref(STATES.CLOSED)
    const guards = []

    function beforeChange(callback) {
        guards.push(callback)
    }

    function is(state) {
        return current.value === state
    }

    function isEither(...states) {
        states = Array.isArray(states[0]) ? states[0] : states

        return states.reduce((passed, state) => passed || is(state), false)
    }

    function open() {
        request(STATES.OPENING)
    }

    function close() {
        if (isEither(STATES.OPENING, STATES.OPEN)) {
            request(STATES.CLOSING)
        }
    }

    // function toggle() {
    //     isEither([STATES.OPEN, STATES.OPENING]) ? close() : open()
    // }

    function request(state) {
        // Apply state change if passes guards
        if (guards.reduce((passed, callback) => passed && callback(state), true)) {
            current.value = state
        }
    }

    // Emit changes on context (Modal component)
    beforeChange((next) => {
        let cancelled = false

        emit(next, () => (cancelled = true))

        return !cancelled
    })

    return {
        beforeChange,
        current,
        open,
        close,
        is,
        isEither,
        request,
        // toggle,
    }
}
